var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("div", { key: "1", staticClass: "my-6" }, [_c("Spinner")], 1)
    : _vm.checkoutType === "single"
    ? _c(
        "div",
        { key: "2", staticClass: "pb-4", attrs: { id: "app checkout" } },
        [
          _c("div", { staticClass: "container my-5" }, [
            _c("div", { staticClass: "row d-flex justify-content-evenly" }, [
              _c("div", { staticClass: "col-lg-5 col-xl-4" }, [
                _c("div", [_c("Summary")], 1),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-5 col-xl-4 mb-5" }, [
                _c(
                  "div",
                  [
                    _c("RegisterLogin"),
                    _vm._v(" "),
                    _vm.defaultCheckout ? _c("Invoice") : _vm._e(),
                    _vm._v(" "),
                    _c("Shipment"),
                    _vm._v(" "),
                    _c("PaymentButton"),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm.checkoutType === "membership"
    ? _c(
        "div",
        { key: "3", staticClass: "pb-4", attrs: { id: "app checkout" } },
        [
          _c("div", { staticClass: "container my-5" }, [
            _c("div", { staticClass: "row d-flex justify-content-evenly" }, [
              _c("div", { staticClass: "col-lg-5 col-xl-4" }, [
                _c("div", [_c("PlanSummary")], 1),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-5 col-xl-4 mb-0 mb-lg-5" }, [
                _c(
                  "div",
                  [
                    _c("RegisterLogin"),
                    _vm._v(" "),
                    _vm.showTpayCardForm ? _c("CardForm") : _vm._e(),
                    _vm._v(" "),
                    _vm.showPayuCardForm ? _c("PayuCardForm") : _vm._e(),
                    _vm._v(" "),
                    _vm.defaultCheckout ? _c("Invoice") : _vm._e(),
                    _vm._v(" "),
                    _c("PaymentButton"),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }